import { useSessionRecordingStore } from '../audio/useSessionRecordingStore/useSessionRecordingStore';

export const useSessionRecording = () => {
  const status = useSessionRecordingStore((s) => s.status);
  const start = useSessionRecordingStore((s) => s.startTask);
  const stop = useSessionRecordingStore((s) => s.stopTask);
  return { start, stop, status };
};
